var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.3335V23.4169C3.5 23.7042 3.62293 23.9797 3.84173 24.1829C4.06052 24.3861 4.35725 24.5002 4.66667 24.5002H23.3334C23.6428 24.5002 23.9396 24.3861 24.1584 24.1829C24.3772 23.9797 24.5001 23.7042 24.5001 23.4169V9.3335H3.5Z",
    fill: "#EFE8E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6751 4.6665H2.3418V9.33318H25.6751V4.6665Z",
    fill: "#9C9188"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3431 11.375H11.6764C11.0321 11.375 10.5098 11.8973 10.5098 12.5417V13.125C10.5098 13.7693 11.0321 14.2917 11.6764 14.2917H16.3431C16.9874 14.2917 17.5098 13.7693 17.5098 13.125V12.5417C17.5098 11.8973 16.9874 11.375 16.3431 11.375Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon_box.201bbaf8f239f3a81d8ff3bd63e99281.svg";
export { ForwardRef as ReactComponent };